import React from "react";
import FlexContainer from "../../../../connectui/component/layout/FlexContainer";
import Container from "../../../../connectui/component/layout/Container";
import Text from "../../../../connectui/component/display/Text";
import {useTheme} from "../../../../connectui/theme/ThemeProvider";
import ButtonIcon from "../../../../connectui/component/input/button/ButtonIcon";
import SvgIcon from "../../../../connectui/component/display/SvgIcon";
import ICONS from "../../../../connectui/icons/iconMap";
import EmptyButtonBase from "../../../../connectui/component/input/button/base/EmptyButtonBase";
import {useDispatch} from "react-redux";
import {
  closeGeneralSuccessAlert,
  openGeneralSuccessAlert,
} from "../../../../redux/actions/settingsActions";
import {format, isAfter, isBefore} from "date-fns";
import ChipText from "../../../../connectui/component/display/chip/ChipText";
import Tooltip from "../../../../connectui/component/display/Tooltip";

export default function DeviceAccessCodeEntry({
  visible,
  deviceCode = {},
  disabled,
  onDelete,
  toggleVisibility = () => {},
}) {
  const {theme} = useTheme();
  const dispatch = useDispatch();
  const codeNotAvailable =
    !deviceCode.access_code ||
    ["setting", "failed"].includes(deviceCode.status);

  const handleCopyCode = () => {
    navigator.clipboard.writeText(deviceCode.access_code);
    dispatch(
      openGeneralSuccessAlert({
        open: true,
        message: "Copied code to clipboard!",
        onClose: () => dispatch(closeGeneralSuccessAlert()),
      }),
    );
  };

  const getStatusLabel = () => {
    if (deviceCode.status === "unset") return "Unset";
    if (!!deviceCode.end) {
      if (isAfter(new Date(Number(deviceCode.start)), new Date())) {
        return `Active from ${format(new Date(Number(deviceCode.start)), "MMM d")} to ${format(new Date(Number(deviceCode.end)), "MMM d")}`;
      }
      if (isBefore(new Date(Number(deviceCode.end)), new Date())) {
        return "Expired";
      }
      return `Expires on ${format(new Date(Number(deviceCode.end)), "MMM d")}`;
    }
    return "Permanent";
  };

  return (
    <Container
      padding={theme.spacing(2)}
      sx={{
        borderRadius: theme.radius.md,
        backgroundColor: theme.colors.gray100,
      }}
    >
      <FlexContainer justifyContent={"space-between"} alignItems={"center"}>
        <FlexContainer flexDirection={"column"}>
          <FlexContainer
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            gap={theme.spacing(2)}
          >
            <Tooltip tooltipContent={deviceCode.name || "Unnamed Device"}>
              <Text
                variant="textSM"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "140px",
                  marginBottom: "0px",
                }}
              >
                {deviceCode.name || "Unnamed Device"}
              </Text>
            </Tooltip>
            <ChipText text={getStatusLabel()} />
          </FlexContainer>

          <FlexContainer
            flexDirection="row"
            alignItems="center"
            gap={theme.spacing(1)}
          >
            <Text variant="textSM">
              {!visible
                ? deviceCode.access_code?.replace(/./g, "•")
                : deviceCode.access_code}
            </Text>
            {!codeNotAvailable && (
              <ButtonIcon
                buttonBase={EmptyButtonBase}
                onClick={() => toggleVisibility(deviceCode.access_code)}
                icon={
                  <SvgIcon
                    component={visible ? ICONS["eye-off"] : ICONS.eye}
                    sx={{height: "18px", width: "18px"}}
                  />
                }
              />
            )}
          </FlexContainer>
        </FlexContainer>
        <FlexContainer alignItems="center" gap={theme.spacing(0)}>
          {!codeNotAvailable && (
            <ButtonIcon
              buttonBase={EmptyButtonBase}
              onClick={handleCopyCode}
              icon={
                <SvgIcon
                  component={ICONS.copy}
                  sx={{height: "18px", width: "18px"}}
                />
              }
            />
          )}
          {!disabled && (
            <ButtonIcon
              buttonBase={EmptyButtonBase}
              onClick={() => onDelete(deviceCode.access_code)}
              icon={
                <SvgIcon
                  component={ICONS.trash}
                  sx={{height: "18px", width: "18px"}}
                />
              }
            />
          )}
        </FlexContainer>
      </FlexContainer>
    </Container>
  );
}
